import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "wrapper-outer",
  style: {
    "line-height": "1.5"
  }
};
const _hoisted_2 = {
  class: "div-086"
};
const _hoisted_3 = {
  key: 0,
  class: "submit-div"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_5 = {
  class: "audit-card"
};
const _hoisted_6 = {
  style: {
    "width": "30%",
    "text-align": "left",
    "font-weight": "bold"
  }
};
const _hoisted_7 = {
  style: {
    "width": "50%",
    "text-align": "center"
  }
};
const _hoisted_8 = {
  style: {
    "width": "20%",
    "text-align": "right"
  }
};
const _hoisted_9 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_10 = {
  style: {
    "flex": "1",
    "word-break": "break-all",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_iop_event = _resolveComponent("iop-event");
  const _component_sensitive_words = _resolveComponent("sensitive-words");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_form = _resolveComponent("el-form");
  const _component_audit_state = _resolveComponent("audit-state");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_detail_aside = _resolveComponent("detail-aside");
  const _component_src_audit = _resolveComponent("src-audit");
  const _component_offer_ref_demand_dialog = _resolveComponent("offer-ref-demand-dialog");
  const _directive_loading = _resolveDirective("loading");
  const _directive_disable = _resolveDirective("disable");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    class: "body-scroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "formRef",
      "label-position": 'top',
      "label-width": "80px",
      model: _ctx.demand
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _ctx.demand.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.demand.name = $event),
                placeholder: "请输入需求名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求人",
            prop: "=userName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row prop-val-text"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.demand.createrName) + "    " + _toDisplayString(_ctx.demand.createrDepName), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "短信有效期",
            prop: "validDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              style: {
                "width": "400px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                readonly: "",
                modelValue: _ctx.demand.validDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.demand.validDate = $event),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD",
                type: "datetimerange",
                "default-time": _ctx.defaultRangeTime,
                "range-separator": "~",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期"
              }, null, 8, ["modelValue", "default-time"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "联系方式"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row prop-val-text"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.demand.phone), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求内容",
          prop: "remark",
          style: {
            "width": "100%",
            "display": "none"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 3,
            modelValue: _ctx.demand.remark,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.demand.remark = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col margin-10-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "业务归属部门",
            prop: "smsType",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              disabled: "",
              modelValue: _ctx.belongDepart,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.belongDepart = $event),
              placeholder: "请选择",
              style: {
                "margin-left": "2%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.belongDeparts, depart => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: depart.code,
                  label: depart.label,
                  value: depart.code
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "IOP短信发送渠道",
            prop: "smsType",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              disabled: "",
              modelValue: _ctx.demand.smsType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.demand.smsType = $event),
              placeholder: "请选择",
              style: {
                "margin-left": "2%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsTypes, type => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: type.id,
                  label: type.nodeName,
                  value: type.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _ctx.demand.smsType === 'RTFLOW' || _ctx.demand.smsType === 'EC10001' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "IOP事件",
            prop: "iopEvent",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_iop_event, {
              disabled: true,
              positionId: _ctx.smsAssetsInfo.positionId,
              "onUpdate:positionId": _cache[5] || (_cache[5] = $event => _ctx.smsAssetsInfo.positionId = $event)
            }, null, 8, ["positionId"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "短信内容",
          prop: "smsContent",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: !_ctx.submitAgain,
            type: "textarea",
            rows: 3,
            modelValue: _ctx.smsAssetsInfo.content,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.smsAssetsInfo.content = $event),
            maxlength: "200",
            "show-word-limit": ""
          }, null, 8, ["disabled", "modelValue"])]),
          _: 1
        }), _createVNode(_component_sensitive_words, {
          "sens-words-list": _ctx.sensWordsList
        }, null, 8, ["sens-words-list"])]),
        _: 1
      }), _ctx.canResubmit ? (_openBlock(), _createElementBlock("div", _hoisted_3, [!_ctx.submitAgain ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        round: "",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = $event => $setup.handleSubmitAgain(_ctx.submitAgain))
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("修改重提 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.submitAgain ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: _cache[8] || (_cache[8] = $event => _ctx.submitAgain = false)
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("取消", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _cache[16] || (_cache[16] = _createTextVNode("   ", -1)), _ctx.submitAgain ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        onClick: _cache[9] || (_cache[9] = $event => $setup.handleSubmitAgain(_ctx.submitAgain))
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("确认", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        class: "prop-col",
        style: {
          "display": "block"
        }
      }, {
        default: _withCtx(() => [_cache[18] || (_cache[18] = _createTextVNode(" 需求附件： ", -1)), _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file, ind) => {
          return _openBlock(), _createElementBlock("div", {
            class: "file-div",
            key: ind
          }, [_createTextVNode(_toDisplayString(file.fileName) + " ", 1), _createVNode(_component_el_button, {
            link: "",
            onClick: $event => $setup.downloadAttach(file)
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("下载", -1)]))]),
            _: 1
          }, 8, ["onClick"])]);
        }), 128))]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col form-margin offer-div"
      }, {
        default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("span", {
          class: "form-font"
        }, "关联产品offerId：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerIds, offerId => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: offerId,
            class: "mx-1",
            "disable-transitions": false
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(offerId), 1)]),
            _: 2
          }, 1024);
        }), 128)), _ctx.offerIds.length > 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          onClick: _cache[10] || (_cache[10] = $event => _ctx.offerDemandVisible = true)
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" 查看相关需求 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"]), _ctx.demand.state != 0 ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        style: {
          "line-height": "32px"
        }
      }, {
        default: _withCtx(() => [_cache[24] || (_cache[24] = _createTextVNode(" 审核详情 ", -1)), _ctx.smsAssetsInfo.state == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_ctx.process && _ctx.process.status ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          disabled: ""
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("已提交领导复审 ", -1)]))]),
          _: 1
        })) : _ctx.demand.createrId == _ctx.userInfo.userId ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: $setup.mngerAudit
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("提交领导复审 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsAssetsInfo.approveInfos, appr => {
          return _openBlock(), _createBlock(_component_el_col, {
            span: 12,
            key: appr.roleId
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(appr.roleName) + " | " + _toDisplayString(_ctx.auditTip[appr.approveState + 1]) + " ", 1), _createVNode(_component_audit_state, {
                state: appr.approveState
              }, null, 8, ["state"])]), _createElementVNode("div", _hoisted_7, _toDisplayString(appr.approveTime), 1), _createElementVNode("div", _hoisted_8, [$setup.showAuditBtn($setup.smsAuditRoleAuth[appr.roleId]) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_ctx.canAudit ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                plain: "",
                onClick: $event => $setup.showAuditDialog({
                  roleId: appr.roleId,
                  roleName: appr.roleName,
                  aprroveContent: appr.aprroveContent
                })
              }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" 审核 ", -1)]))]),
                _: 1
              }, 8, ["onClick"])), [[_directive_disable, $setup.smsAuditRoleAuth[appr.roleId]]]) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                disabled: "",
                type: "info",
                plain: ""
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(appr.approveState == 0 ? "审核" : "已审核"), 1)]),
                _: 2
              }, 1024))], 64)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024), _ctx.smsAssetsInfo.state != -1 && appr.approveState == 0 ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" 暂未审核 ", -1)]))]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_row, {
              key: 1
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[27] || (_cache[27] = _createElementVNode("div", {
                style: {
                  "width": "80px"
                }
              }, "审核意见：", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(appr.aprroveContent), 1)])]),
              _: 2
            }, 1024))])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })]), _createVNode(_component_detail_aside, {
    ref: "asideRef",
    demandId: _ctx.demandId
  }, null, 8, ["demandId"]), _createVNode(_component_src_audit, {
    visible: _ctx.auditDialogShow,
    "onUpdate:visible": _cache[11] || (_cache[11] = $event => _ctx.auditDialogShow = $event),
    auditRole: _ctx.auditRole,
    multiSrss: _ctx.auditSMss,
    onSuccess: $setup.toBack,
    onSave: $setup.loadSmsAssets
  }, null, 8, ["visible", "auditRole", "multiSrss", "onSuccess", "onSave"]), _createVNode(_component_offer_ref_demand_dialog, {
    visible: _ctx.offerDemandVisible,
    "onUpdate:visible": _cache[12] || (_cache[12] = $event => _ctx.offerDemandVisible = $event),
    "offer-ids": _ctx.offerIds,
    "ne-src-id": _ctx.smsAssetsInfo.srcId
  }, null, 8, ["visible", "offer-ids", "ne-src-id"])], 64);
}